module.exports = __webpack_public_path__ + "img/p62-cover-1982.6b0f3c5b.jpg";